import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const deleteStructureType = ({ denominationId, structureTypeId }) => {
  return axios.delete(
    `/denominations/${denominationId}/structure-types/${structureTypeId}`
  );
};

export const useDeleteStructureType = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["structure-types"]);
      queryClient.invalidateQueries(["structure-types-paginated"]);

      setNotification({
        type: "success",
        message: "Structure type deleted successfully!"
      });

      closeDeleteModal();
    },
    ...config,
    mutationFn: deleteStructureType
  });
};
